<template>
  <!-- Inspiration: Code de Jean-François Lavigne (Sidlee) -->
  <!-- https://codepen.io/jflavigne/pen/MWpKpPG -->

  <div :class="jel_getClassObject(content)" class="w-100 ios-margin">
    <b-aspect :aspect="formatCarte" class="w-100">
      <div class="card" :class="`format-${content.formatCarte}`">
        <div class="card-body d-flex">
          <slot></slot>
        </div>
      </div>
    </b-aspect>
  </div>
</template>

<script>
export default {
  name: 'Carte',
  props: { content: { type: Object, required: true } },
  data() {
    return {
      isHovered: false,
    };
  },
  computed: {
    formatCarte() {
      let formatCarteTransforme = this.content.formatCarte;
      // TODO: Vérifier si cette condition est redondante, potentiellement déjà géré
      if (formatCarteTransforme === '4x3' && !this.jel_isEcranDesktop(this.$mq)) {
        formatCarteTransforme = '5x7';
      }
      return formatCarteTransforme?.replace(/x/g, ':');
    },
  },
  methods: {
    handleHover(hovered) {
      this.isHovered = hovered;
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: #fff;
  border-radius: 25px;
  overflow: hidden;
  height: 100%;
}

.card-body {
  padding: 0;
  display: flex;
  flex-direction: column;
  border: 0;
  text-decoration: none;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  -webkit-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
}

.card:hover {
  -webkit-box-shadow: 2px 2px 6px 3px rgba(155, 155, 155, 0.5);
  box-shadow: 2px 2px 6px 3px rgba(155, 155, 155, 0.5);
}

.card:focus {
  outline: none;
  -webkit-box-shadow: 0px 0px 0px 2px #0b5db7, 2px 2px 6px 3px rgba(155, 155, 155, 0.5);
  box-shadow: 0px 0px 0px 2px #0b5db7, 2px 2px 6px 3px rgba(155, 155, 155, 0.5);
}

.card:active {
  outline: none;
  -webkit-box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.5),
    2px 2px 3px 3px rgba(155, 155, 155, 0.5);
  box-shadow: 0px 0px 0px 2px rgba(255, 255, 255, 0.5), 2px 2px 3px 3px rgba(155, 155, 155, 0.5);
}
@supports (-webkit-touch-callout: none) and (not (translate: none)) {
  .card-body {
    height: 10vh;
  }
}

@media not all and (min-resolution: 0.001dpcm) {
  @supports not (-webkit-touch-callout: none) {
    .card-body {
      height: 5vh;
    }
    .ios-margin {
      margin-bottom: 10px;
    }
  }
}
</style>
